import { createContext, useContext } from 'react'

export const TimelineStaticContext = createContext(null)

export const useTimelineStaticContext = () => {
  const context = useContext(TimelineStaticContext)
  if (!context) throw new Error('useTimelineStaticContext must be used within TimelineContextProvider')
  return context
}
